<script>
  import { previews_nav_filters, previews_search_filter, previews_storefronts_filter, detected_fonts, previews_tags_filter } from '../stores'
  import { isEmpty } from 'lodash'
  import Insert_TaggingEmptyState from '../content/TaggingEmptyState.svelte'
  import DroppedFontsEmptyState from '../content/DroppedFontsEmptyState.svelte'
  import StorefrontEmptyState from '../content/StorefrontEmptyState.svelte';
  import StorefrontsEmptyState from '../content/StorefrontsEmptyState.svelte';
  import UploadedFontsEmptyState from '../content/UploadedFontsEmptyState.svelte';

  $: is_showing_extension_fonts = $detected_fonts && $detected_fonts.length > 0 && $detected_fonts[0]?.source === 'extension'
  $: is_showing_local_fonts = $detected_fonts && $detected_fonts.length > 0 && $detected_fonts[0]?.source === 'local'

</script>

<div class="EmptyState content" class:centered={$previews_nav_filters.storefront && !!$previews_storefronts_filter}>
  <!-- All/System Fonts -->
  {#if isEmpty($previews_nav_filters) && $previews_search_filter === ''}
    Unfortunately, we cannot show the system fonts installed on this operating system.
  {/if}

  <!-- Your Fonts -->
  {#if $previews_nav_filters.user && $previews_nav_filters.tagged === undefined}
    {#if $previews_search_filter === '' && (is_showing_local_fonts || is_showing_extension_fonts)}
      <p>
        Wordmark couldn't find any fonts apart from your system fonts.<br>
        Install new fonts on your computer to see them here!
      </p>
    {/if}
  {/if}

  <!-- Tagged Fonts -->
  {#if $previews_nav_filters.tagged && $previews_search_filter === ''}
    {#if $previews_tags_filter.length === 0}
      <Insert_TaggingEmptyState/> 
    {:else}
      There are no fonts with selected tags
    {/if}
  {/if}

  <!-- Dropped Fonts -->
  {#if $previews_nav_filters.dropped && $previews_search_filter === ''}
    <DroppedFontsEmptyState/> 
  {/if}

  {#if $previews_nav_filters.tagged === false && $previews_search_filter === ''}
    You have no untagged fonts
  {/if}

  <!-- Search -->
  {#if $previews_search_filter !== ''}
    There are no fonts matching your search criteria
  {/if}

  <!-- Storefronts with no fonts -->
  {#if $previews_nav_filters.storefront && !$previews_storefronts_filter}
    <StorefrontsEmptyState/>
  {/if}

  <!-- Storefront with no fonts -->
  {#if $previews_nav_filters.storefront && !!$previews_storefronts_filter}
    <StorefrontEmptyState/>
  {/if}

  <!-- Uploaded Fonts -->
  {#if $previews_nav_filters.uploaded}
    <UploadedFontsEmptyState/>
  {/if}
</div>

<style>
  .content {
    width: 100%;
    min-height: calc(100% - 28rem);
    font-size: 1.6rem;
    text-align: left;
    background-color: var(--c-bg);
  }
  .content.centered {
    display: flex;
    width: 100%;
    margin-bottom: -2rem;
    border-radius: 0.5rem;
    background-color: var(--c-pill-bg);
  }
  p {
    font-family: var(--PensumSans);
    font-weight: normal;
    font-size: 1.6rem;
    margin-top: 2rem;
  }
</style>